import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { GET_STAFF_MANAGEMENT_AUDIT_LOGS } from "graphql/query/staff-management-gql";
import StaffManagement from "components/staff-management";
import { Tables } from "components/layout";
import {
    getStaffAuditQueryState,
    STAFF_AUDIT_LOG_ORDER_BY,
    STAFF_AUDIT_LOG_PAGE_SIZE,
} from "components/staff-management/helpers/staff-audit-log-api-helper";


const StaffManagementAuditLogSubPage = ({ event }) => {
    const history = useHistory();
    const routeUrl = `${ StaffManagement.Const.basePath }/${ event.id }/audit-log`;
    const match = useRouteMatch(`${ routeUrl }/page/:pageNum`);
    const parsedPage = match ? Number(match.params.pageNum) : 1;
    const validRequestedPage = Number.isInteger(parsedPage) && parsedPage > 0;
    const canonicalPagePath = !match || (validRequestedPage && parsedPage > 1);
    const requestedPage = validRequestedPage ? parsedPage : 1;
    const [ searchText, setSearchText ] = useState("");
    const [ period, setPeriod ] = useState([]);
    const [ subcontractorID, setSubcontractorID ] = useState();
    const [ result, setResult ] = useState();
    const [ action, setAction ] = useState();
    const [ scanLocation, setScanLocation ] = useState();
    const queryState = useMemo(() => getStaffAuditQueryState({
        eeID: event.id,
        period,
        action,
        result,
        subcontractorID,
    }), [ action, event.id, period, result, subcontractorID ]);

    const resetPage = useCallback(() => {
        if (requestedPage !== 1)
        {
            history.push(routeUrl);
        }
    }, [ history, requestedPage, routeUrl ]);

    const tableHelper = useMemo(() => (
        StaffManagement.Helpers.AuditLogTable(setScanLocation)
    ), []);

    useEffect(() => {
        if (!canonicalPagePath)
        {
            history.replace(routeUrl);
        }
    }, [ canonicalPagePath, history, routeUrl ]);

    return (
        <>
            <div className="staff-management-view-shell--audit-log">
                <Tables.Main
                    model="workSessionLogs"
                    query={ GET_STAFF_MANAGEMENT_AUDIT_LOGS }
                    routeUrl={ routeUrl }
                    currentPage={ requestedPage }
                    searchText={ searchText }
                    objFilter={ queryState.where }
                    objOrderBy={ STAFF_AUDIT_LOG_ORDER_BY }
                    varSet={ {
                        perPage: STAFF_AUDIT_LOG_PAGE_SIZE,
                        result: queryState.result,
                        whereUser: queryState.whereUser,
                    } }
                    tableHelper={ tableHelper }
                    extraClass="staff-audit-table"
                    scroll={ { x: 1318 } }>
                    <StaffManagement.Filters.AuditLogTable
                        eventSubcontractors={ event.relWorkerSubcontractors || [] }
                        searchText={ searchText }
                        setSearchText={ setSearchText }
                        period={ period }
                        setPeriod={ setPeriod }
                        subcontractorID={ subcontractorID }
                        setSubcontractorID={ setSubcontractorID }
                        result={ result }
                        setResult={ setResult }
                        action={ action }
                        setAction={ setAction }
                        resetPage={ resetPage } />
                </Tables.Main>
            </div>

            <StaffManagement.Fields.ScanLocationModal
                event={ event }
                open={ Boolean(scanLocation) }
                location={ scanLocation }
                onClose={ () => setScanLocation(undefined) } />
        </>
    );
};

export default StaffManagementAuditLogSubPage;
